import styled from 'styled-components';

export const Heading = styled.div.attrs({
  className: 'bg-secondary h2 m-0 mb-3 p-3 rounded-3 px-4',
})``;
export const Section = styled.div.attrs({
  className: 'row gx-3 mx-auto px-0 px-lg-4',
})``;
